import React from "react";
import Apps from "./Apps";

const GoogleApps = () => {
    return (
        <div className="container-apps">
            <div className="wrapper-apps">
                <Apps
                    image_url="https://lh3.googleusercontent.com/COxitqgJr1sJnIDe8-jiKhxDx1FrYbtRHKJ9z_hELisAlapwE9LUPh6fcXIfb5vwpbMl4xl9H9TRFPc5NOO8Sb3VSgIBrfRYvW6cUA"
                    name="Search"
                />
                <Apps
                    image_url="https://lh3.googleusercontent.com/V0Lu6YzAVaCVcjSJ_4Qb0mR_idw-GApETGbkodvDKTH-rpDvHuD6J84jshR_FvXdl5mJxqbIHVdebYCCbQMJNxIxRaIHYFSq6z7laA"
                    name="Maps"
                />
                <Apps
                    image_url="https://lh3.googleusercontent.com/3_OFn2skqHXk-UQ-9RUdNrDl_HQJrMCxks5teQcUrF_bOSeDG1hD8j83FeD31W8hASZCvubzsGfumuJq8kvvSAq03wY87RZ7Otx_DF4"
                    name="Youtube"
                />
                <Apps
                    image_url="https://lh3.googleusercontent.com/V6C9KmBzAK48_si_jPMSgUrBhdCGL8-z8QMg-WvDqSdVdPXN-FZHrpCHaZaYAYuXCGK-G85sYRIy3PdqfXAS4QlXwQJTyNUPYCpz"
                    name="Keep"
                />
                <Apps
                    image_url="https://lh3.googleusercontent.com/n3Eac1gPc5OTEh7Go1jemICnooceXtfs4VZW-4CPukCUi_doFsN9Q8njidksZ4KIFyPJVYtR7ZhLL16VoUJSPE1j74iTXT2xwCqq"
                    name="Meet"
                />
                <Apps
                    image_url="https://lh3.googleusercontent.com/hK3UrUgS8y0fmfFlxr7hQFdKdkufJQ5aDWjB9Ft2hTLkVUaZTWTH_w5AvXU3C4zko7w1RVLEUQf0DnQ_id9c32IZ6upSLMVfhSWnJg"
                    name="Chat"
                />
                <Apps
                    image_url="https://lh3.googleusercontent.com/VEnnK2SyklusfxZ3dIYjlQH3xSwK2BFSJ69TFQ9g8HjM6m3CouRlTia5FW3z3GS0x83WC9TylZCaA9Jf_2kmr7mXxI9_HYLZTFy_bg"
                    name="Cloud"
                />
                <Apps
                    image_url="https://lh3.googleusercontent.com/rCwHBRBJV4wFiEIN_Mlboj94_TGJxyJtBh-MBFL4y1aZdO4hb7_Uc_PpXRyAoN7O9m_Zc1wSyp3H1vsnb829QE7t9KyGNJY9A1a3QQ"
                    name="Drive"
                />
                <Apps
                    image_url="https://lh3.googleusercontent.com/GjNHryPo7CDf0S6k0xZJdqGuyM0FpR5-_YbN1ZMiJ9HlrATxMrbn6P48SC1U6yTc8FkhIT7WX5qGeq59I5_FIXawoi-nKNIVbbydcg"
                    name="Duo"
                />
                <Apps
                    image_url="https://lh3.googleusercontent.com/BwoectM66uur7vsy6UNtarl_XM67Uu7qUakYNj8nh2OuwczsPmwMSLy0BJ6YpN3IXXCytOJHWeVgXkY4NomrvVMgwLVqLjgsaR7Nng"
                    name="Play"
                />
                <Apps
                    image_url="https://lh3.googleusercontent.com/9agKA1CG--ihx80qoPwq8xVFZ0i0_nEyLpXlcf8juPbFXe13GhUBR7Y5xOO3LVfnmM06OtrWw086uFlQ9s5jNPlvXJNBQViCvB4L4Q"
                    name="News"
                />
                <Apps
                    image_url="https://lh3.googleusercontent.com/0rpHlrX8IG77awQMuUZpQ0zGWT7HRYtpncsuRnFo6V3c8Lh2hPjXnEuhDDd-OsLz1vua4ld2rlUYFAaBYk-rZCODmi2eJlwUEVsZgg"
                    name="Gmail"
                />
            </div>
        </div>
    );
};

export default GoogleApps;
